export default __webpack_public_path__ + "static/media/error.532ea75d.svg";